
export default class Banner {

  public link: string;
  public target: string;
  public width: string;
  public image?: string;

//   <ContactRow name={"John Smith"} title={"Title"} email={"john.smith@dynatrace.com"} phoneNumber={"Tel. +1 630-886-9981"} image={matt_howard} />
  constructor(link: string, target: string, width: string, image?: string) {
    this.link = link;
    this.target = target;
    this.width = width;
    this.image = image;
  }

}
